import { Button } from "primereact/button";
import React from "react";
const FileUpdateDetails = ({
  fileUploadStatus,
  setShowStats,
  isFromBulkUpdate,
  setData,
  setFileUploadDetails,
  setHeader,
  setDuplicateRows,
  setColor,
  setAddUnits,
}) => {
  const handleCardClick = (dataArray, header, color) => {
    if (dataArray?.length > 0) {
      setData(dataArray);
      setHeader(header);
      setColor(color);
      setFileUploadDetails(false);
      setShowStats(true);
    }
  };

  return (
    <div className="fileuploaddetails">
      <div className="fileuploaddetailsinner">
        <button
          className="backicon"
          onClick={() => {
            if (isFromBulkUpdate) setFileUploadDetails(false);
            else setAddUnits(false);
          }}
        >
          <i
            className="pi pi-angle-left"
            style={{ fontSize: "1.5rem", color: "#323232" }}
          ></i>
        </button>

        <h1>BULK UPDATE STATUS</h1>

        {/* Success / Updated */}
        <div className="successupload">
          <div
            className={
              fileUploadStatus?.updated?.length > 0
                ? "simnumbershover"
                : "simnumbers"
            }
            style={{
              borderColor: fileUploadStatus?.updated?.length
                ? "#27AE60"
                : "#E1E4F3",
            }}
            onClick={() =>
              handleCardClick(
                fileUploadStatus?.updated,
                "UPDATED SIM/IMEI",
                "success"
              )
            }
          >
            <label>UPDATED</label>
            <h1>{fileUploadStatus?.updated?.length || 0}</h1>
          </div>

          <div
            className={
              fileUploadStatus?.mapping?.length > 0
                ? "imeinumbershover"
                : "imeinumbers"
            }
            style={{
              borderColor: fileUploadStatus?.mapping?.length
                ? "#27AE60"
                : "#E1E4F3",
            }}
            onClick={() =>
              handleCardClick(
                fileUploadStatus?.mapping,
                "MAPPED ITEMS",
                "success"
              )
            }
          >
            <label>MAPPED</label>
            <h1>{fileUploadStatus?.mapping?.length || 0}</h1>
          </div>
          <div
            className={
              fileUploadStatus?.notFound?.length > 0
                ? "simnumbershover"
                : "simnumbers"
            }
            style={{
              borderColor: fileUploadStatus?.notFound?.length
                ? "#b3261e"
                : "#E1E4F3",
            }}
            onClick={() =>
              handleCardClick(fileUploadStatus?.notFound, "NOT FOUND", "danger")
            }
          >
            <label>NOT FOUND</label>
            <h1>{fileUploadStatus?.notFound?.length || 0}</h1>
          </div>
        </div>

        {/* Errors / Not Found */}

        <div className="errors">
          {" "}
          <div
            className={
              fileUploadStatus?.validationErrors?.length > 0
                ? "imeinumbershover"
                : "imeinumbers"
            }
            style={{
              borderColor: fileUploadStatus?.validationErrors?.length
                ? "#b3261e"
                : "#E1E4F3",
            }}
            onClick={() =>
              handleCardClick(
                fileUploadStatus?.validationErrors,
                "VALIDATION ERRORS",
                "danger"
              )
            }
          >
            <label>VALIDATION ERRORS</label>
            <h1>{fileUploadStatus?.validationErrors?.length || 0}</h1>
          </div>
        </div>

        <div style={{ paddingRight: "3rem" }} className="fileuploaddetailbtn">
          <Button
            label="Back"
            className="backbtn"
            onClick={() => setFileUploadDetails(false)}
          />
        </div>
      </div>
    </div>
  );
};

export default FileUpdateDetails;
